import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";
import { SimpleModal } from "src/app/components";
import { useForbiddenKeywordsList } from "src/app/hooks";
import { ForbiddenKeywordTranport } from "src/app/transports/forbiddenKeyword";

export interface IForbiddenKeywordsModalContainer {
    showModal?: boolean;
    handleClose?(): void;
}

const ForbiddenKeywordsModalContainer = (props: IForbiddenKeywordsModalContainer) => {
    const { showModal, handleClose = () => {} } = props;
    const { formatMessage } = useIntl();
    const [keywords, setKeywords] = useState("");
    const [loading, setLoading] = useState(false);
    const { forbiddenKeywordsList, loading: forbiddenKeywordsListloading } =
        useForbiddenKeywordsList();

    useEffect(() => {
        if (forbiddenKeywordsList) {
            setKeywords(
                forbiddenKeywordsList
                    ?.map((el) => el.keyword)
                    .toString()
                    .replaceAll(",", "\n")
            );
        }
    }, [forbiddenKeywordsList]);

    const handleSubmit = async () => {
        try {
            setLoading(true);
            await ForbiddenKeywordTranport.save(keywords);
            handleClose();
            toast.success(formatMessage({ id: "common.notification.success" }));
        } catch {
            toast.error(formatMessage({ id: "common.notification.error" }));
        } finally {
            setLoading(false);
        }
    };

    return (
        <SimpleModal
            formId="forbiddenKeywords"
            entityName="forbiddenKeywords"
            showModal={showModal}
            handleClose={handleClose}
            loading={forbiddenKeywordsListloading || loading}
            modalProps={{ size: undefined }}
        >
            <Form
                id="forbiddenKeywords"
                onSubmit={(e) => {
                    e.preventDefault();
                    handleSubmit();
                }}
            >
                <Form.Label>Add keywords</Form.Label>
                {!forbiddenKeywordsListloading && (
                    <Form.Control
                        as="textarea"
                        value={keywords}
                        onChange={(e) => setKeywords(e.currentTarget.value)}
                        rows={15}
                    />
                )}
            </Form>
        </SimpleModal>
    );
};

export default ForbiddenKeywordsModalContainer;
